"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Route = void 0;
var Route;
(function (Route) {
    Route["Base"] = "/auth";
    /* Interim Screen children */
    Route["InterimScreen"] = "interim-screen";
    Route["InterimScreenOpen"] = "open";
    Route["InterimScreenOpenTimeout"] = "open-timeout";
    Route["InterimScreenProcess"] = "process";
})(Route || (exports.Route = Route = {}));
